import React from 'react';

import * as styles from './socialLinks.module.scss';
import Img from "gatsby-image"


export const SocialLinks = ({ socials }) =>  (
  <div className={styles.socialLinks}>
    {socials
      .sort((a, b) => a.position - b.position)
      .map((social: any, idx: number) => (
      <a
        key={idx}
        href={social.slug}
        target="_blank"
        className={styles.socialLink}
        rel="noopener noreferrer"
        aria-label="Link opens in a new window"
        title="Link opens in a new window"
      >
        {/* <GatsbyImage
          image={social.image.gatsbyImageData}
          alt={social.image.title}
        /> */}
         <Img fluid={social.image.fluid} alt={social.image.title} />
      </a>
    ))}
  </div>
);